import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";

/** Terms of Service — plain, honest, human-readable. */
export default function Terms() {
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="terms-hero"
        eyebrow="Legal"
        title="Terms of Service"
        sub="Plain-English terms. If something isn't clear, email contact@wikifi.app and we'll fix it."
      />
      <article className="prose prose-sm max-w-none text-[#0B1220] space-y-6 text-[14px] leading-relaxed" data-testid="terms-body">
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">1. What Wikificial is</h2>
          <p className="text-[#5B6478]">
            Wikificial is a directory and workspace for AI tools. We list, score,
            and explain third-party AI products so you can find the right one for
            your work. Wikifi is our multi-model synthesis assistant.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">2. Your account</h2>
          <p className="text-[#5B6478]">
            You need an account to save favorites, run Wikifi conversations, or
            subscribe to a paid plan. You're responsible for keeping your login
            secure. Don't share your credentials.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">3. Acceptable use</h2>
          <p className="text-[#5B6478]">
            Don't use Wikificial to break laws, harass anyone, scrape at scale
            without asking, or resell our content as your own. Automated abuse
            (rate-limit evasion, credential stuffing, catalog scraping) gets your
            account suspended without notice.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">4. Third-party AI answers</h2>
          <p className="text-[#5B6478]">
            Wikifi's answers are generated by third-party AI models
            (OpenAI, Anthropic, Google, xAI, Perplexity). They can be wrong.
            Not medical, legal, or financial advice — verify what matters.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">5. Payments and refunds</h2>
          <p className="text-[#5B6478]">
            Paid plans are billed through Stripe. Cancel any time from your
            dashboard — you keep access until the end of the current billing
            period. Refund requests within 7 days of purchase are granted on a
            good-faith basis; email contact@wikifi.app.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">6. Changes to these terms</h2>
          <p className="text-[#5B6478]">
            We'll email you before any change that materially reduces your
            rights. Minor edits (typos, clarifications) can happen without
            notice. The current version always lives at this URL.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">7. Questions</h2>
          <p className="text-[#5B6478]">
            Email contact@wikifi.app or use the Contact form. We reply within
            two business days.
          </p>
        </section>
        <div className="text-[11px] text-[#8A93A6] pt-4">Last updated: February 2026.</div>
      </article>
    </Layout>
  );
}
